import { message } from "antd";
import {doGet, doGetMappingUser, doGetSession, doGetToken, doLogin, doPWA, doPost} from '../api/baseAPI';
import { GROLOG_AUTH, GROLOG_URL } from "../constant/apiConstant";
import {
  clearSession,
  setActiveUser,
  setAuthentication,
  setAuthLoading,
  setErrorAuth,
  setFirstName,
  setLastName,
  setMappingUser,
  setRefreshToken,
  setToken,
  setUserId,
} from '../store/reducer/authentication.reducer';

export const DoLogin = async (data, dispatch) => {
  let status = {isAuthenticated: false}
  const url = `${GROLOG_URL}/session/login/login`
  dispatch(setAuthLoading(true))
  try {
    const response = await doLogin(url, data)
    if (response) {
      dispatch(setToken(response.headers.authorization))
      dispatch(setRefreshToken(response.data.nexsoft.payload.data.content.refresh_token))
      dispatch(setUserId(response.data.nexsoft.payload.data.content.user_id))
      dispatch(setFirstName(response.data.nexsoft.payload.data.content.first_name))
      dispatch(setLastName(response.data.nexsoft.payload.data.content.last_name))
      dispatch(setErrorAuth(''))
      const responseGetMapping = await getMappingUser(response.headers.authorization, dispatch)
      if (responseGetMapping.isGetUser) {
        dispatch(setAuthentication(true))
        status.isAuthenticated = true
      }
    }
  } catch (error) {
    // ErrorHandler(error, dispatch)
  }

  return status
}

export const getMappingUser = async (token, dispatch) => {
  let status = {isGetUser: false}
  const url = `${GROLOG_URL}/session/getmappinggrokiosaccount`
  try {
    const response = await doGetMappingUser(url, token)
    if (response) {
      dispatch(setMappingUser(response.data.nexsoft.payload.data.content))
      status.isGetUser = true
    }
  } catch (error) {
    // ErrorHandler(error)
  }

  return status
}

export const getSession = async (token, grokios_account_id, dispatch) => {
  let status = {isGetSession: false}
  const url = `${GROLOG_URL}/session/sessionservice`

  try {
    const response = await doGetSession(url, token, grokios_account_id)
    if (response) {
      dispatch(setActiveUser(grokios_account_id))
      //   setFallbackPage()
      status.isGetSession = true
    }
  } catch (error) {
    // ErrorHandler(error, dispatch)
  }

  return status
}

export const getRefreshToken = async (token, refresh_token, dispatch, navigate) => {
  const url = `${GROLOG_URL}/session/refreshtoken/refreshtoken`

  try {
    const response = await doPost(url, token, {refresh_token: refresh_token}, null)
    if (response) {
      dispatch(setToken(response.headers.authorization))
      dispatch(setRefreshToken(response.data.nexsoft.payload.data.content.refresh_token))
    }
  } catch (error) {
    dispatch(clearSession())
    error.response.data.nexsoft.payload.status.message &&
      message.error(error.response.data.nexsoft.payload.status.message)
  }
}

export const DoLogout = async (token) => {
  let result = {status: false, message: undefined}
  const url = `${GROLOG_URL}/session/logout/logout`

  const res = await doGet(token, url, null)
  if (res) {
    result.status = true
    result.message = res.data.nexsoft.payload.status.message
  } else {
    result.status = false
    result.message = res.data.nexsoft.payload.status.message
  }

  return result
}

export const getInternalToken = async () => {
  let result = { status: false, internal_token: undefined }
  const url = `${GROLOG_AUTH}/session/token-internal-grochat`;

  const { status, data } = await doGetToken(url);
  
  if (status === 200) {
    result.status = true;
    result.internal_token = data?.payload
  }

  return result
}

export const authPWA = async (body) => {
  let result = { status: false, data: undefined }
  const url = `${GROLOG_AUTH}/authorize/user/auth-pwa`;

  const { status, data } = await doPWA(url, body);
  
  if(status === 200){
    result.status = true;
    result.data = data?.payload;
  }

  return result;
}